const icon = require('vue-svgicon');
icon.register({
    'attention': {
        width: 3,
        height: 17,
        viewBox: '0 0 3 17',
        data: `<path pid="0" d="M0 16.54v-2.545h2.533v2.545H0zM1.267 11.45c-.7 0-1.267-.57-1.267-1.272V1.27C0 .568.567 0 1.267 0c.699 0 1.266.568 1.266 1.271v8.907a1.27 1.27 0 01-1.266 1.272z" _fill="#6737AF"/>`,
    },
});
